import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Form, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../config/api';
import './Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSubmitted(false);

    try {
      await api.post('/user/auth/forgot-password', { email: email.trim() });
      setSubmitted(true);
      toast.success("If an account exists, we've sent a reset link to your email.");
    } catch (error) {
      toast.error(error.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <Container>
        <div className="auth-card">
          <h1 className="auth-title">Forgot Password</h1>
          <p className="auth-subtitle">
            Enter your email and we&apos;ll send you a link to reset your password.
          </p>

          {submitted ? (
            <>
              <p className="text-center mb-4" style={{ color: '#333' }}>
                Check your inbox (and spam folder) for a link to reset your password.
              </p>
              <div className="auth-switch">
                <p>
                  <Link to="/login">Back to Login</Link>
                </p>
              </div>
            </>
          ) : (
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Control
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="Email"
                  className="auth-input"
                />
              </Form.Group>

              <Button type="submit" className="auth-submit-btn" disabled={loading}>
                {loading ? 'Sending...' : 'Send reset link'}
              </Button>

              <div className="auth-switch">
                <p>
                  Remember your password? <Link to="/login">Login</Link>
                </p>
              </div>
            </Form>
          )}
        </div>
      </Container>
    </div>
  );
};

export default ForgotPassword;
